import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4b648e94"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { class: "page" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, { class: "header" }, {
        default: _withCtx(() => [
          _createVNode(_component_Search, {
            menu: _ctx.menu,
            searchData: _ctx.searchData,
            onClickItem: _ctx.searchJump
          }, null, 8, ["menu", "searchData", "onClickItem"]),
          _hoisted_1,
          _createVNode(_component_Menu, {
            mode: 'horizontal',
            theme: 'light',
            data: _ctx.topMenu,
            selectedKeys: _ctx.topselected,
            onItemclick: _ctx.handleClickTop
          }, null, 8, ["data", "selectedKeys", "onItemclick"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout, { style: {"display":"flex"} }, {
            default: _withCtx(() => [
              _createVNode(_component_a_layout_sider, {
                width: "170",
                style: {"background":"#fff"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Menu, {
                    mode: 'inline',
                    theme: 'light',
                    data: _ctx.leftMenu,
                    selectedKeys: _ctx.leftselected,
                    onItemclick: _ctx.handleClickleft
                  }, null, 8, ["data", "selectedKeys", "onItemclick"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_layout, { style: {"padding":"0","width":"100%"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_Breadcrumb, { menu: _ctx.menu }, null, 8, ["menu"]),
                  _createVNode(_component_a_layout_content, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_view)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}